import CityPageTemplate from "../city-template/CityPageTemplate";
import { clovisConfig } from "./data";

export default function ClovisPage() {
  return <CityPageTemplate config={clovisConfig} />;
}